/* Actions */
import { ACTION_TYPES_BASE_NAME } from "./actions";

/* Others */
import { makeFetchReducers, FETCH_REDUCERS_KEYS } from "../../../utils";

const reducers = makeFetchReducers(ACTION_TYPES_BASE_NAME, null, { whitelistedKeys: [FETCH_REDUCERS_KEYS.STATUS] });

export default reducers;
